// Глобальний компонент іконки: <tkd-icon name="kyorugi" /> (розмір = font-size, колір = color)
// Необов'язково: size="20" | "1.5em", title="Підказка" (тоді іконка не aria-hidden).
import ICONS from './icons';
import './tkd-icon.css';

function escapeHtml(s) {
  return String(s).replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
}

export default {
  name: 'TkdIcon',
  functional: true,
  props: {
    name: { type: String, required: true },
    size: { type: [String, Number], default: null },
    title: { type: String, default: null },
  },
  render(h, { props, data }) {
    const body = ICONS[props.name];
    if (!body && process.env.NODE_ENV !== 'production') {
      console.warn('[tkd-icon] невідома іконка:', props.name);
    }
    const size = props.size == null ? '1em' : (typeof props.size === 'number' ? props.size + 'px' : props.size);
    return h('svg', {
      ...data,
      staticClass: ['tkd-icon', 'tkd-icon--' + props.name, data.staticClass].filter(Boolean).join(' '),
      attrs: {
        viewBox: '0 0 24 24',
        width: size,
        height: size,
        fill: 'none',
        stroke: 'currentColor',
        'stroke-width': '1.8',
        'stroke-linecap': 'round',
        'stroke-linejoin': 'round',
        focusable: 'false',
        role: props.title ? 'img' : null,
        'aria-hidden': props.title ? null : 'true',
        ...(data.attrs || {}),
      },
      domProps: {
        innerHTML: (props.title ? '<title>' + escapeHtml(props.title) + '</title>' : '') + (body || ''),
      },
    });
  },
};
